if (!customElements.get('collapsible-content')) {
  customElements.define(
    'collapsible-content',
    class CollapsibleContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const accordions = this.querySelectorAll('details');

        accordions.forEach((accordion) => {
          accordion.addEventListener('toggle', this.handleToggle.bind(this));
        });
      }

      disconnectedCallback() {
        const accordions = this.querySelectorAll('details');
        accordions.forEach((accordion) => {
          accordion.removeEventListener('toggle', this.handleToggle.bind(this));
        });
      }

      handleToggle(event) {
        const accordions = this.querySelectorAll('details');

        if (event.target.open) {
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== event.target && otherAccordion.open) {
              otherAccordion.open = false;
            }
          });
        }
      }
    },
  );
}
